import React from 'react';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';
import { MaterialIcon } from '.';
import './InlineHelp.scss';
let inlineHelpId = 1;
export function InlineHelp({ href, children }) {
    const key = `help-${inlineHelpId++}`;
    if (href) {
        return React.createElement("span", { className: 'inline-help' },
            " (",
            React.createElement("a", { href: href, target: '_blank' }, children || 'Help'),
            ")");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: 'inline-icon', id: key },
            React.createElement(MaterialIcon, { name: 'info', small: true })),
        React.createElement(UncontrolledPopover, { placement: 'bottom', target: key, trigger: 'hover' },
            React.createElement(PopoverBody, null, children))));
}
//# sourceMappingURL=InlineHelp.js.map